// Environment detection utility
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development' || 
         window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         (window.location.hostname.includes('netlify.app') && window.location.hostname.includes('dev'));
};

export const isProduction = () => {
  return !isDevelopment();
};

// Feature flags
export const shouldShowAffiliateFeatures = () => {
  // Publicly enable affiliate features across environments
  return true;
};

export const shouldShowAffiliateRoutes = () => {
  // Always allow routes to work (for testing), but hide UI elements in production
  return true;
};
